import React, { Fragment, useRef } from "react";
import dotracking from "../../../../trackinglogs";
import trackobj from "../../../../trackingpages.json";
import { useEffect } from "react";
import {
  scheadtourviewdetail,
  schoolheadfreetouredit,
  schprofileview,
} from "../../../../../services/schoolhead";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  addathleteplayerlist,
  checkextpaymentpaidornot,
  checkpaymentpaidornot,
  confplayerlist,
} from "../../../../../services/common";
import { Card, Col, Container, Row } from "react-bootstrap";
import {
  crmprofileview,
  crmtourviewdetail,
} from "../../../../../services/cityregionaladmin";
import { tourviewdetail } from "../../../../../services/superadmin";
import Swal from "sweetalert2";
import moment from "moment";
import {
  swimaddathleteplayerlist,
  swimcheckextpaymentpaidornot,
  swimcheckpaymentpaidornot,
  swimconfplayerlist,
  swimschoolheadfreetouredit,
} from "../../../../../services/swimmingapi";
import { coachtourviewdetail } from "../../../../../services/coach";

export const ConfirmationPlayer = () => {
  const [tname, setTName] = useState("");
  const [tsport, setTSport] = useState("");

  const { id, eid } = useParams();
  const navigate = useNavigate();
  const [plist, setPList] = useState([]);
  const [s3path, setS3Path] = useState("");
  const [ddate, setDDate] = useState("");

  const [gateway, setGateway] = useState("");
  const [paytype, setPayType] = useState("");

  const [payornot, setPayorNot] = useState("");
  const [tfree, setTFree] = useState("");
  const [schid, setSchID] = useState("");
  const [disptype, setDispType] = useState("");

  useEffect(() => {
    if (localStorage.getItem("Role") === "1") {
      setSchID(eid)

      tourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setDDate(response.data.tournament.entry_deadline_date);
          setTFree(response.data.tournament.free_tournament);
          setTName(response.data.tournament.meet_name);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);

          if (response.data.tournament.tournament_display_type !== null) {
            setDispType(response.data.tournament.tournament_display_type);
          }
          if (response.data.tournament.payment_gateway_type == 1) {
          } else {
            if (
              response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
            ) {
              checkextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                }
              });
            } else if (
              response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
            ) {
              swimcheckextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                }
              });
            }
          }

          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            addathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          }
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
    setSchID(eid)

      crmtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setDDate(response.data.tournament.entry_deadline_date);
          setTFree(response.data.tournament.free_tournament);
          setTName(response.data.tournament.meet_name);
          setTSport(response.data.tournament.sports_type);

          if (response.data.tournament.tournament_display_type !== null) {
            setDispType(response.data.tournament.tournament_display_type);
          }
          setGateway(response.data.tournament.payment_gateway_type);
          if (response.data.tournament.payment_gateway_type == 1) {
            if (
              response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
            ) {
              checkpaymentpaidornot(id, eid, 0).then((response) => {
                if (response.status === true) {
                  setPayorNot(response.data.Payment_Status);
                  if (response.data.Payment_Status === "Pending") {
                    navigate("/cityregional/addathletes/" + id + "/" + eid);
                  }
                }
              });
            } else if (
              response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
            ) {
              swimcheckpaymentpaidornot(id, eid, 0).then((response) => {
                if (response.status === true) {
                  setPayorNot(response.data.Payment_Status);
                  if (response.data.Payment_Status === "Pending") {
                    navigate("/cityregional/swimaddathletes/" + id + "/" + eid);
                  }
                }
              });
            }
          } else {
            if (
              response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
            ) {
              checkextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                  setPayorNot("Pending");
                  if (res.data.exteral_receipt.approve_or_reject == 2) {
                    navigate("/cityregional/playerlist/" + id + "/" + eid);
                  }
                }
              });
            } else if (
              response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
            ) {
              swimcheckextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                  setPayorNot("Pending");
                  if (res.data.exteral_receipt.approve_or_reject == 2) {
                    navigate("/cityregional/swimplayerlist/" + id + "/" + eid);
                  }
                }
              });
            }
          }

          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            addathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          }
        }
      });
    } else if (localStorage.getItem("Role") === "4") {
      scheadtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setDDate(response.data.tournament.entry_deadline_date);
          setTFree(response.data.tournament.free_tournament);
          setTName(response.data.tournament.meet_name);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);

          if (response.data.tournament.tournament_display_type !== null) {
            setDispType(response.data.tournament.tournament_display_type);
          }
          schprofileview().then((resp) => {
            if (resp.status === true) {
              setSchID(resp.data.school_id);
              if (response.data.tournament.payment_gateway_type === 1) {
                if (
                  response.data.tournament.sports_type.toUpperCase() ==
                  "ATHLETICS"
                ) {
                  checkpaymentpaidornot(id, resp.data.school_id, 0).then(
                    (res) => {
                      if (res.status === true) {
                        setPayorNot(res.data.Payment_Status);

                        if (res.data.Payment_Status === "Pending") {
                          navigate("/schoolhead/addathletes/" + id);
                        }
                      }
                    }
                  );
                } else if (
                  response.data.tournament.sports_type.toUpperCase() ==
                  "SWIMMING"
                ) {
                  swimcheckpaymentpaidornot(id, resp.data.school_id, 0).then(
                    (res) => {
                      if (res.status === true) {
                        setPayorNot(res.data.Payment_Status);

                        if (res.data.Payment_Status === "Pending") {
                          navigate("/schoolhead/swimaddathletes/" + id);
                        }
                      }
                    }
                  );
                }
              } else if (response.data.tournament.payment_gateway_type === 2) {
                if (
                  response.data.tournament.sports_type.toUpperCase() ==
                  "ATHLETICS"
                ) {
                  checkextpaymentpaidornot(id, resp.data.school_id).then(
                    (res) => {
                      if (
                        res.status === true &&
                        res.data.exteral_receipt !== null
                      ) {
                        setPayType(res.data.exteral_receipt.approve_or_reject);
                        if (res.data.exteral_receipt.approve_or_reject === 0) {
                          setPayorNot("Paid");
                        }
                        if (res.data.exteral_receipt.approve_or_reject === 2) {
                          navigate("/schoolhead/addathletes/" + id);
                        }
                      }
                    }
                  );
                } else if (
                  response.data.tournament.sports_type.toUpperCase() ==
                  "SWIMMING"
                ) {
                  swimcheckextpaymentpaidornot(id, resp.data.school_id).then(
                    (res) => {
                      if (
                        res.status === true &&
                        res.data.exteral_receipt !== null
                      ) {
                        setPayType(res.data.exteral_receipt.approve_or_reject);
                        if (res.data.exteral_receipt.approve_or_reject === 0) {
                          setPayorNot("Paid");
                        }
                        if (res.data.exteral_receipt.approve_or_reject === 2) {
                          navigate("/schoolhead/swimaddathletes/" + id);
                        }
                      }
                    }
                  );
                }
              }
              if (
                response.data.tournament.sports_type.toUpperCase() ==
                "ATHLETICS"
              ) {
                addathleteplayerlist(id, resp.data.school_id).then(
                  (response) => {
                    if (response.status === true) {
                      setPList(response.data.details);
                      setS3Path(response.data.s3path);
                    }
                  }
                );
              } else if (
                response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
              ) {
                swimaddathleteplayerlist(id, resp.data.school_id).then(
                  (response) => {
                    if (response.status === true) {
                      setPList(response.data.details);
                      setS3Path(response.data.s3path);
                    }
                  }
                );
              }
            }
          });
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      setSchID(eid)

      coachtourviewdetail(id).then((response) => {
        if (response.status === true && response.data.tournament !== null) {
          setDDate(response.data.tournament.entry_deadline_date);
          setTFree(response.data.tournament.free_tournament);
          setTName(response.data.tournament.meet_name);
          setGateway(response.data.tournament.payment_gateway_type);
          setTSport(response.data.tournament.sports_type);

          if (response.data.tournament.tournament_display_type !== null) {
            setDispType(response.data.tournament.tournament_display_type);
          }
          if (response.data.tournament.payment_gateway_type == 1) {
          } else {
            if (
              response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
            ) {
              checkextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                }
              });
            } else if (
              response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
            ) {
              swimcheckextpaymentpaidornot(id, eid).then((res) => {
                if (res.status === true && res.data.exteral_receipt !== null) {
                  setPayType(res.data.exteral_receipt.approve_or_reject);
                }
              });
            }
          }

          if (
            response.data.tournament.sports_type.toUpperCase() == "ATHLETICS"
          ) {
            addathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          } else if (
            response.data.tournament.sports_type.toUpperCase() == "SWIMMING"
          ) {
            swimaddathleteplayerlist(id, eid).then((response) => {
              if (response.status === true) {
                setPList(response.data.details);
                setS3Path(response.data.s3path);
              }
            });
          }
        }
      });
    }
  }, []);

  function edittour() {
    Swal.fire({
      text: "Are you sure want to Edit the Entries?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#19d610",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (localStorage.getItem("Role") === "4") {
          dotracking(
            "edit entries button in confirmation for school (" +
              schid +
              ") in " +
              tname +
              " (" +
              id +
              ") tournament $$ " +
              trackobj.tourplayerheading
          );
          const temp = new FormData();
          temp.append("tournament_meet_id", id);
          temp.append("school_id", schid);
          temp.append("admin_id", localStorage.getItem("UID"));
          if (tsport.toUpperCase() === "ATHLETICS") {
            schoolheadfreetouredit(temp).then((res) => {
              if (res.status === true) {
                navigate("/schoolhead/playerlist/" + id);
              }
            });
          } else if (tsport.toUpperCase() === "SWIMMING") {
            swimschoolheadfreetouredit(temp).then((res) => {
              if (res.status === true) {
                navigate("/schoolhead/swimplayerlist/" + id);
              }
            });
          }
        }
      }
    });
  }
  function backlist() {
    if (localStorage.getItem("Role") === "1") {
      dotracking(
        "back button in confirmation for school (" +
          eid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.tourlistheading
      );
      navigate("/superadmin/tournamentlist");
    } else if (localStorage.getItem("Role") === "3") {
      dotracking(
        "back button in confirmation for school (" +
          eid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.tourlistheading
      );
      navigate("/cityregional/tournamentlist");
    } else if (localStorage.getItem("Role") === "4") {
      if (localStorage.getItem("Page") === "1") {
        dotracking(
          "back button in confirmation for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.tourlistheading
        );
        navigate("/schoolhead/tournamentlist");
      } else if (localStorage.getItem("Page") === "3") {
        dotracking(
          "back button in confirmation for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.comtourlistheading
        );
        navigate("/schoolhead/completedtournament");
      } else {
        dotracking(
          "back button in confirmation for " +
            tname +
            " (" +
            id +
            ") tournament $$ " +
            trackobj.dashheading
        );
        navigate("/schoolhead/dashboard");
      }
    }else if (localStorage.getItem("Role") === "7") {
      dotracking(
        "back button in confirmation for school (" +
          eid +
          ") in " +
          tname +
          " (" +
          id +
          ") tournament $$ " +
          trackobj.tourlistheading
      );
      navigate("/coach/tournamentlist");
    }
  }

  function errorhandle(ev) {
    ev.target.src = require("../../../../../assets/images/users.png");
    ev.target.onerror = null;
  }
  const printRef = useRef();

  const downloadPDF = () => {
    dotracking(
      "download PDF button in schedule list for " +
        tname +
        " (" +
        id +
        ") tournament $$ " +
        trackobj.confirmplayerheading
    );
    if (tsport.toUpperCase() === "ATHLETICS") {
      confplayerlist(id, schid).then((res) => {
        if (res) {
          window.open(res.pdf_path + res.pdf_name, "_blank");
        }
      });
    } else if (tsport.toUpperCase() === "SWIMMING") {
      swimconfplayerlist(id, schid).then((res) => {
        if (res) {
          window.open(res.pdf_path + res.pdf_name, "_blank");
        }
      });
    }
    // const element = printRef.current;

    // // Options for html2pdf.js
    // const options = {
    //   margin: 10,                // Set the margins for the PDF
    //   filename: 'Confirmation.pdf', // Filename for the PDF
    //   image: { type: 'jpeg', quality: 0.98 }, // Image settings if needed
    //   html2canvas: {
    //     scale: 2,               // Increase resolution for better quality
    //     logging: true,          // Enable logging for debugging
    //     useCORS: true,          // Allow cross-origin images
    //   },
    //   jsPDF: {
    //     unit: 'mm',             // Unit for the PDF
    //     format: 'a4',           // PDF format (A4 in this case)
    //     orientation: 'portrait', // Portrait or landscape orientation
    //   },
    // };

    // // Generate the PDF with the selected options
    // html2pdf()
    //   .from(element)           // Pass in the element to convert
    //   .set(options)            // Set the options
    //   .save();                 // Automatically trigger the download of the PDF
  };

  return (
    <div className="side-app">
      <div className="page-header">
        <div className="breadcrumb">
          <h4 className="mb-0">Confirmation</h4>
        </div>
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Tournament</a>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Confirmation
          </li>
        </ol>
      </div>
      <div className="col-md-12">
        <div className="text-right">
          {payornot === "Paid" &&
            ddate >= moment(new Date()).format("yyyy-MM-DD") &&
            tfree === "Y" &&
            localStorage.getItem("Role") === "4" && (
              <a className="btn btn-success mx-1" onClick={edittour}>
                <i className="fa fa-edit"></i> Edit Entries
              </a>
            )}
          <a className="btn btn-export mx-1" onClick={downloadPDF}>
            <i className="fa fa-file-pdf"></i> Download PDF
          </a>
          <a className="btn btn-gray mx-2" onClick={backlist}>
            <i className="fe fe-corner-up-left"></i> Back
          </a>
        </div>
      </div>
      <div className="row mt-2" ref={printRef}>
        <div className="col-12">
          <form className="card mt-0">
            <div className="card-body">
              <h3>{tname}</h3>
              {localStorage.getItem("Role") !== "1" && (
                <div className="mt-5">
                  <div className="text-center text-white background-text ">
                    <h1 className="mb-3 text-success">
                      Thank you for submitting all the entries !
                    </h1>

                    {gateway == 2 && paytype == 0 && (
                      <h1 className="mb-3 text-danger">
                        Please wait for admin approval.
                      </h1>
                    )}
                    {gateway == 2 && paytype == 1 && (
                      <h1 className="mb-3 text-danger">
                        Your entry has been approved by Admin.
                      </h1>
                    )}
                  </div>
                </div>
              )}
            </div>
          </form>
        </div>
        <div className="col-12">
          {/* <form className="card mt-0">
            <div className="card-body"> */}
          <div id="playerlist">
            <div className="row">
              {/* {plist.map((data, i) => {
                    return (
                      <div className="col-md-4" key={i}>
                        <div className="box">
                          <div className="box__head">
                            <h1>{data.first_name}</h1>
                          </div>
                          <div className="box__content">
                            <h2>
                              <b>Player UID</b> <span>{data.username}</span>
                            </h2>
                            <h2>
                              <b>Class</b> <span>{data.classname}</span>
                            </h2>
                            <h2>
                              <b>Section</b> <span>{data.section}</span>
                            </h2>
                            <h2>
                              <b>Age Category</b>{" "}
                              <span>{data.age_category}</span>
                            </h2>
                            <h2>
                              <b>BIB Number</b> <span>{data.bib_no}</span>
                            </h2>
                          </div>
                          <div className="box_footer">
                            <h4>Events :-</h4>
                            <p>{data.events}</p>
                          </div>
                        </div>
                      </div>
                    );
                  })} */}

              {plist.map((data, i) => {
                return (
                  <div className="col-md-4" key={i}>
                    <Card className="custom-card">
                      <Card.Body className="athsummbox p-2">
                        <div className="d-flex">
                          <div className="media align-items-center pos-relative w-100">
                            <span className="tx-16 my-auto">
                              {data.photograph !== null && (
                                <img
                                  alt="photograph"
                                  src={s3path + data.photograph}
                                  className="athsummbox-img"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                              {data.photograph === null && (
                                <img
                                  alt="photograph"
                                  src={require("../../../../../assets/images/users.png")}
                                  className="athsummbox-img"
                                  onError={(e) => errorhandle(e)}
                                />
                              )}
                            </span>
                            <div className="media-body ms-3">
                              <h4 className="abname">{data.first_name}</h4>
                              <h4 className="abuid">
                                <span>UID - </span>
                                {data.username}
                              </h4>
                              <h4 className="abdob">
                                <span>DOB - </span>
                                {moment(data.date_of_birth).format(
                                  "DD-MM-YYYY"
                                )}
                              </h4>
                              {disptype !== "Corporate Tournament" && (
                                <>
                                  <h4 className="abdob">
                                    <span>Class - </span>
                                    {data.classname}
                                  </h4>
                                  <h4 className="abdob">
                                    <span>Section - </span> {data.section}
                                  </h4>
                                </>
                              )}

                              <h4 className="abdob">
                                <span>Age Category - </span>
                                {data.age_category}
                              </h4>
                              <h4 className="abdob">
                                <span>BIB Number - </span>
                                {data.bib_no}
                              </h4>
                              <h4 className="abdob">
                                <span>Relay BIB Number - </span>
                                {data.relay_bib_no}
                              </h4>
                              <h4 className="abdob">
                                <span>Events - </span>
                                {data.events}
                              </h4>
                              <h5 className="tx-20 text-success">
                                <span>{data.school_name}</span>
                              </h5>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                );
              })}
            </div>
          </div>
          {/* </div>
          </form> */}
        </div>
      </div>
    </div>
  );
};
